var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.1665C10.25 20.1665 9.53351 19.8638 8.10052 19.2585C4.53351 17.7517 2.75 16.9983 2.75 15.731C2.75 15.3762 2.75 9.22564 2.75 6.4165M11 20.1665C11.75 20.1665 12.4665 19.8638 13.8995 19.2585C17.4665 17.7517 19.25 16.9983 19.25 15.731V6.4165M11 20.1665L11 10.4084",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63209 8.88344L4.95432 7.5877C3.48477 6.8766 2.75 6.52105 2.75 5.95801C2.75 5.39496 3.48477 5.03941 4.95432 4.32832L7.63209 3.03257C9.28477 2.23286 10.1111 1.83301 11 1.83301C11.8889 1.83301 12.7152 2.23286 14.3679 3.03257L17.0457 4.32831C18.5152 5.03941 19.25 5.39496 19.25 5.95801C19.25 6.52105 18.5152 6.8766 17.0457 7.5877L14.3679 8.88344C12.7152 9.68315 11.8889 10.083 11 10.083C10.1111 10.083 9.28477 9.68315 7.63209 8.88344Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11L7.33333 11.9167",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 3.6665L6.41663 8.24984",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.fc51d4ccd3b54d869c6e46dc258359d9.svg";
export { ForwardRef as ReactComponent };